module.exports = "<div class=\"domains\">\n    <div class=\"domains-container\">\n        <dbm-list [listTitle]=\"'Domain Manager'\" [listAction]=\"'Add Domain'\" [listItems]=\"domains\" (onActionClick)=\"addDomain()\"\n            (onListItemClick)=\"selectedDomain = $event.selectedItem\"></dbm-list>\n    </div>\n    <domain-item [domain]=\"selectedDomain\" [hasItems]=\"hasItems || false\" (onDelete)=\"deleteDomain()\"></domain-item>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/usersRolesManagement/advancedManagement/domain-manager/domain-manager.component.html
// module id = 1850
// module chunks = 0